import { initializeApp } from 'firebase/app';
import {
  fetchAndActivate,
  getRemoteConfig,
  getValue,
  setCustomSignals,
} from 'firebase/remote-config';
import { defineStore } from 'pinia';
import { ref } from 'vue';

import { FEATURES, FIREBASE_CONFIG } from './consts';

export const useFirebaseStore = defineStore('remoteConfig', () => {
  const features = ref<Record<string, any>>({});

  const fetchConfig = async () => {
    try {
      const app = initializeApp(FIREBASE_CONFIG);
      const env = process.env.NODE_ENV === 'production' ? window.location.hostname : 'dev';

      const remoteConfig = getRemoteConfig(app);
      remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

      await setCustomSignals(remoteConfig, {
        env,
      });

      await fetchAndActivate(remoteConfig);

      FEATURES.forEach((feature) => {
        features.value[feature] = getValue(remoteConfig, feature).asBoolean();
      });
    } catch (error) {
      console.error('Ошибка загрузки Remote Config:', error);
    }
  };

  return { features, fetchConfig };
});
